<template>
  <div style="z-index:9;position:relative;margin-top:-64px;">
    <div class="container">
      <div class="feature-item1" @click="$router.push(`/views/${plateid}`)">
        <h3 class="feature__title">名师简介</h3>
        <p class="feature__text">全国名校名师信息介绍跨越一个世纪的教育...</p>
      </div>
              <!-- <div class="col-lg-4 col-sm-6">
                  <div class="feature-item feature-item3" @click="$router.push(`/kscx`)">
                      <img src="/static/images/icon_3.png" class="shij">
                      <h3 class="feature__title">成绩查询</h3>
                      <p class="feature__text">输入学号查询测评成绩</p>
                  </div>
              </div> -->
      <div class="feature-item2" @click="$router.push(`/courviews`)">
          <h3 class="feature__title">课程中心</h3>
          <p class="feature__text">课程中心信息介绍</p>
      </div>
      <div class="feature-item3" @click="$router.push(`/papercenter`)">
          <h3 class="feature__title">试卷中心</h3>
          <p class="feature__text">试卷中心信息介绍</p>
      </div>
      <div class="feature-item4" @click="$router.push(`/liveview`)">
          <h3 class="feature__title">在线直播</h3>
          <p class="feature__text">在线直播信息介绍</p>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        plateid:"",
        global
    };
  },
  props: {
    plates:Array
  },
  components: {},

  computed: {},

  mounted() {
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="名师简介"){
            this.plateid = this.plates[i]._id;
        }
    }
  },
  methods: {

  }
}

</script>
<style scoped>
.container{
  width: 1200px;
  height: 189px;
  display: flex;
  justify-content: space-between;
}
.feature-item1,.feature-item3,.feature-item4{
  position: relative;
  width: 244px;
height: 189px;
background: #F1AA13;
}
.feature-item2 .feature__title{

background: #3C78DB;
background-image: url(/static/img/kechegn.png);
  background-repeat: no-repeat;
  background-position: 17px center;
}
.feature-item3 .feature__title{

background: #0E9992;
background-image: url(/static/img/shijuan.png);
  background-repeat: no-repeat;
  background-position: 17px center;
}
.feature-item4 .feature__title{

background: #334EB3;
background-image: url(/static/img/zhibo.png);
  background-repeat: no-repeat;
  background-position: 17px center;
}
.feature-item3{

background: #13C0B7;
}
.feature-item4{

background: #4462CF;
}
.feature-item2{
  position: relative;
  width: 471px;
height: 189px;
background: #4A88EE;
background-image: url(/static/img/kechegnzhognxin.png);
  background-repeat: no-repeat;
  background-position: 245px center;
}
</style>